// FormField.tsx
const FormField = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => {
  return (
    <div className="flex flex-col gap-1 w-full">
      <label className="text-xs font-semibold text-gray-500 min-h-[16px]">
        {label}
      </label>
      {children}
    </div>
  );
};

export default FormField;
